export default {
	attendance: "Présence",
	inProgress: "En cours",
	selectConsultant: "Sélectionner un consultant",
	searchConsultant: "Rechercher une personne pour consultation",
	typeToSearch: "Saisissez pour rechercher des consultants",
	noConsultantsFound: "Aucun consultant trouvé",
	changeConsultant: "Modifier",
	loadingHistory: "Chargement de l'historique...",
	noHistoryFound: "Aucun historique trouvé pour ce consultant",
	errorLoadingHistory: "Erreur lors du chargement de l'historique du consultant",
	mediumName: "Médium",
	ticketAssignedSuccess: "Fiche attribuée avec succès !",
	consultationFinishedSuccess: "Consultation terminée avec succès !",
	ticketCancelledSuccess: "Fiche annulée avec succès !",
	ticketDeletedSuccess: "Fiche supprimée avec succès !",
	errorLoadingRitual: "Erreur lors du chargement des informations du rituel",
	ritualNotAvailable: "Ce rituel n'est pas disponible pour la distribution de fiches",
	errorLoadingConsultants: "Erreur lors du chargement des consultants",
	errorCreatingTicket: "Erreur lors de la création de la fiche de présence",
	consultantAlreadyHasTicket: "Ce consultant a déjà une fiche active dans ce rituel",
	consultantHasCancelledTicket: "Ce consultant a une fiche annulée dans ce rituel",
	ticketSlotOccupied: "Cette position de fiche est déjà occupée",
	consultantInfo: "Informations du consultant",
	ticketDetails: "Détails de la fiche",
	consultationTime: "Durée de la consultation",
	viewProfile: "Voir le profil",
	finishConsultation: "Terminer la consultation",
	cancelTicket: "Annuler la fiche",
	deleteTicket: "Supprimer la fiche",
	status: {
		pending: "En attente",
		in_progress: "En cours",
		completed: "Terminé",
		cancelled: "Annulé",
	},
	confirmCancel: "Confirmer l'annulation",
	confirmCancelMessage: "Êtes-vous sûr de vouloir annuler cette fiche ? Le consultant sera bloqué dans ce rituel.",
	confirmDelete: "Confirmer la suppression",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer cette fiche ? Le consultant pourra obtenir une nouvelle fiche.",
	cardInfo: "Carte / Médium · Guide",
	addTicket: "Ajouter",
	selectConsultantFirst: "Sélectionnez d'abord un consultant",
	cardFull: "Cette carte est complète",
	onlyDuringInProgress: "Disponible uniquement lorsque le rituel est en cours",
	noTicketsYet: "Aucune fiche distribuée pour le moment",
	noAttendanceCards: "Aucune carte de présence configurée pour ce type de rituel",
	errorLoadingCards: "Erreur lors du chargement des cartes de présence",
	showNames: "Afficher les noms",
	hideNames: "Masquer les noms",
	hasReservation: "Réservation garantie",
	totalTickets: "Fiches",
	pendingCount: "En attente",
	alreadyHasTicket: "Cette personne a déjà une fiche dans ce rituel",
	assignTicket: "Attribuer une fiche",
	clickToDeselect: "Cliquez pour désélectionner",
	clickToSelect: "Cliquez pour sélectionner la position",
	createNewConsultant: "Inscrire une nouvelle personne",
	errorLoadingConsultant: "Erreur lors du chargement du consultant",
	noActiveRitual: "Aucun rituel en cours pour le moment",
	noAttendanceCardsHint: "Vérifiez si le type de rituel a des types de présence liés dans les paramètres.",
	selected: "Sélectionné",
	preSenha: {
		title: "Numéro de pré-file d'attente",
		called: "Numéro {number} appelé",
		resetSuccess: "Numéro de pré-file d'attente réinitialisé",
		errorCalling: "Erreur lors de l'appel du numéro de pré-file d'attente",
		errorResetting: "Erreur lors de la réinitialisation du numéro de pré-file d'attente",
	},
};
